import {
  BasketballIncidentId,
  CommonIncidentId,
} from '@collector/sportsapi-client-legacy'

import { HistoryFiltersConfig } from '../../configuration'
import { historyFiltersAttributesConfig } from './historyFiltersAttributesConfig'

export const historyFiltersConfig: HistoryFiltersConfig = {
  historyFiltersAttributes: historyFiltersAttributesConfig,
  historyFiltersIncidents: [
    BasketballIncidentId.ThreePointShotMade,
    BasketballIncidentId.TwoPointShotMade,
    BasketballIncidentId.FreeThrowIn,
    BasketballIncidentId.FreeThrowsAwarded,
    BasketballIncidentId.ThreePointShotMissed,
    BasketballIncidentId.TwoPointShotMissed,
    BasketballIncidentId.FreeThrowIn,
    BasketballIncidentId.DefensiveRebound,
    BasketballIncidentId.OffensiveRebound,
    BasketballIncidentId.Turnover,
    BasketballIncidentId.Steal,
    BasketballIncidentId.Block,
    BasketballIncidentId.Foul,
    CommonIncidentId.Betstop,
    CommonIncidentId.Betstart,
    BasketballIncidentId.Timeout,
    BasketballIncidentId.TvTimeout,
    CommonIncidentId.TechnicalProblems,
    CommonIncidentId.MatchResumed,
    BasketballIncidentId.BreakDuringTheGame,
    BasketballIncidentId.Injury,
  ],
}
